var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 209.6 66.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1, .st2 {\n        isolation: isolate;\n      }\n\n      .st0, .st2 {\n        fill: #fff;\n        font-family: Poppins-Medium, Poppins;\n        font-size: 10.8px;\n        font-weight: 500;\n      }\n\n      .st3 {\n        fill: #ee3e51;\n      }\n\n      .st2 {\n        letter-spacing: .7em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(0 59.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ADVERTISING.LL")), /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(193.3 59.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37,23c0,12.8-8.7,21.4-20.5,21.4H1.4V1.6h15.1c11.8,0,20.5,8.5,20.5,21.4M29.3,23c0-8.5-5.2-14.2-13-14.2h-7.4v28.5h7.4c7.8,0,13-5.7,13-14.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "90.5 8.7 77.6 8.7 77.6 1.6 110.8 1.6 110.8 8.7 98 8.7 98 44.3 90.5 44.3 90.5 8.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 116.2,
    y: 1.6,
    width: 7.5,
    height: 42.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "139.5 37.2 161.9 37.2 161.9 44.3 129.3 44.3 129.3 38.5 152.3 8.7 132.2 8.7 132.2 1.6 162.4 1.6 162.4 7.4 139.5 37.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M165.1,23c0-12.3,8.8-22,21.5-22s21.5,9.9,21.5,22-8.8,22-21.5,22-21.5-9.7-21.5-22M200.5,23c0-8.2-5.9-14.7-13.8-14.7s-13.8,6.5-13.8,14.7,5.9,14.7,13.8,14.7,13.8-6.4,13.8-14.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 43.3,
    y: 1.5,
    width: 28.4,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.5,12.2c-9.1,0-16.4,7.4-16.4,16.4s7.4,16.4,16.4,16.4,16.4-7.4,16.4-16.4-7.4-16.4-16.4-16.4ZM57.5,37.8c-5.1,0-9.2-4.1-9.2-9.2s4.1-9.2,9.2-9.2,9.2,4.1,9.2,9.2-4.1,9.2-9.2,9.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.59f2de20974653eb67f1487d72bd2404.svg";
export { ForwardRef as ReactComponent };